import { render, staticRenderFns } from "./LodgingshowExperienceAndPrivileges.vue?vue&type=template&id=2cff3ca4&scoped=true&"
import script from "./LodgingshowExperienceAndPrivileges.vue?vue&type=script&lang=js&"
export * from "./LodgingshowExperienceAndPrivileges.vue?vue&type=script&lang=js&"
import style0 from "./LodgingshowExperienceAndPrivileges.vue?vue&type=style&index=0&id=2cff3ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff3ca4",
  null
  
)

export default component.exports